module.exports = __webpack_public_path__ + "img/html-evolution-6.40a58b42.webp";